import { app, regl } from '../app';
import createDrawPoints from './drawPoints';
import colors from './colors';

export default function animate() {

  // Layout points
  app.layouts[app.layoutIndex]();

  // Create the regl function with the new start and end points
  const drawPoints = createDrawPoints(regl, app.points);

  // Start an animation loop
  app.loading = false;
  let startTime = null;

  const frameLoop = regl.frame(({ time }) => {
    // Keep track of start time so we can get time elapsed
    if (startTime === null) {
      startTime = time;
    }

    // Clear the buffer
    regl.clear({
      color: colors.dark.vector,
      depth: 1,
    });

    // Draw the points using our created regl func
    drawPoints({
      startTime,
      pointWidth: app.pointWidth,
      duration: app.duration,
      delayByIndex: app.delayByIndex,
      stageWidth: window.innerWidth,
      stageHeight: window.innerHeight,
    });

    // End animation loop once max duration has passed
    if (time - startTime > app.maxDuration / 1000) {
      frameLoop.cancel();
      app.animating = false;
    }
  });
}



// WEBPACK FOOTER //
// ./src/helpers/animate.js